import cl from 'classnames'
import React from 'react'
import { CollapsibleItem } from '../collapsible-item/index'

import styles from './styles.module.scss'

interface DataProps {
  title: string
  content: JSX.Element
}

interface Props {
  data: DataProps[]
  className?: string
}

export const ListOptions = ({ data, className }: Props) => {
  return (
    <div className={cl(styles.container, className)}>
      {data?.map(item => (
        <React.Fragment key={item.title}>
          <CollapsibleItem question={item.title} className="w-full">
            {item.content}
          </CollapsibleItem>
          <div className={styles.divisor}></div>
        </React.Fragment>
      ))}
    </div>
  )
}
